import {
  CenteredContent,
  ButtonPrimary,
  SpacerVertical,
  IllustrationErrorExplodingBalloon
} from 'mage-deps/@klarna/bubble-ui'
import PropTypes from 'prop-types'
import React from 'react'
import StaticAppWrapper from '../containers/StaticAppWrapper'

const NotFound = ({ t }) => {
  return (
    <StaticAppWrapper id='notFound'>
      <SpacerVertical large />
      <CenteredContent
        illustration={<IllustrationErrorExplodingBalloon />}
        title={t('static-pages.notFound.title')}
        summary={t('static-pages.notFound.details')}
      >
        <ButtonPrimary onClick={() => { window.history.back() }}>
          {t('static-pages.notFound.goBack')}
        </ButtonPrimary>
      </CenteredContent>
    </StaticAppWrapper>
  )
}

NotFound.propTypes = {
  t: PropTypes.func.isRequired
}

export default NotFound
